import { http } from '@/lib/axios';
import { unwrap, toApiError } from '@/lib/unwrap';
import { ApiError, type ApiEnvelope } from '@/types/api';
import type { CouponValidation } from '@/types/coupon';

/**
 * POST /coupon/validate { code }. On an invalid coupon the BE returns a 4xx
 * with an `errorCode`; we surface that as a structured `CouponValidation`
 * with `valid: false` so the UI can render per-case copy without a throw.
 */
export async function validateCoupon(code: string): Promise<CouponValidation> {
  try {
    const res = await http.post<ApiEnvelope<CouponValidation>>('/coupon/validate', { code });
    const data = unwrap(res.data);
    return { ...data, code, valid: data.valid ?? true };
  } catch (error) {
    const err = toApiError(error);
    if (err instanceof ApiError && err.code >= 400 && err.code < 500) {
      return {
        code,
        valid: false,
        message: err.message,
        errorCode: err.errorCode ?? undefined,
      };
    }
    throw err;
  }
}
